



































import { Component, Vue, Prop } from "vue-property-decorator";
import { Filter } from "@/domainproject/filter";
import { Color } from "@/domainproject/colors";

@Component({
  watch: {
    firstWord: function(this: WordToggle) {
      this.updateWords();
    },
    middleWords: function(this: WordToggle) {
      this.updateWords();
    },
    lastWord: function(this: WordToggle) {
      this.updateWords();
    }
  }
})
export default class WordToggle extends Vue {
  @Prop() color!: Color;
  @Prop() initialWords!: Filter;

  firstWord = true;
  middleWords = true;
  lastWord = true;

  mounted() {
    this.firstWord = this.initialWords.$_firstWord;
    this.middleWords = this.initialWords.$_middleWords;
    this.lastWord = this.initialWords.$_lastWord;
  }

  updateWords() {
    this.$emit("toggle", [this.firstWord, this.middleWords, this.lastWord]);
  }
}
